<template>
  <div class="c-card order-history">
    <div class="c-card--title">
      <h3>{{$t('profile.invoice.title')}}</h3>
    </div>
    <div class="c-card--content with-scrollbar">
      <div class="booking-wrapper" v-if="bookings.length > 0">
        <invoice-booking v-for="(booking, index) in bookings" :key="booking.id" :index="index" :booking="booking"/>
      </div>
      <div class="loader" v-if="loading">
        <loader/>
      </div>
      <div class="more" v-else-if="hasMore">
        <button class="btn" @click="loadMore">
          {{$t('bookingHistory.load-more')}}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import Loader from "../../../components/loader.component";
import InvoiceBooking from "./order-history/invoice-booking";

export default {
  name: "order-history",
  components: {InvoiceBooking, Loader},
  computed: {
    ...mapState({
      loading: s => s.bookingHistory.loading,
      bookings: s => s.bookingHistory.bookings,
      hasMore: s => s.bookingHistory.hasMore
    })
  },
  async mounted() {
    await this.$store.dispatch('bookingHistory/fetch');
  },
  async beforeDestroy() {
    await this.$store.dispatch('bookingHistory/reset')
  },
  methods: {
    async loadMore() {
      await this.$store.dispatch('bookingHistory/fetch');
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/client/part/order-history.vue